import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    profileDetails:[],
    passportDetails:[],
    emiratesDetails:[],
    relationshipManagerDetails:[],
    
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileData: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearProfileData: (state) => {
      return initialState;
    },
  },
});

export const { setProfileData,clearProfileData } = profileSlice.actions;
export default profileSlice.reducer;
